import { type IHttpClient } from '@wix/yoshi-flow-editor';
import {
  type LiveUpdatesConfig,
  initializeCommentsController,
} from '@wix/comments-ooi-client/controller';
import { BLOG_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';
import { getPlatformApi } from '@app/external/common/controller/platform-api';
import { getInstance } from '../../../common/controller/helpers';
import { createDuplexerClient } from '../../../common/middleware/duplexer-middleware/create-duplexer-connection';
import { type ControllerConfig } from '../../../common/types';
import type { ErrorHandlerPublicAPI } from '@wix/yoshi-flow-editor/build/cjs/exports/error-handler';

interface Params {
  controllerConfig: ControllerConfig;
  httpClient: IHttpClient;
  errorHandler: ErrorHandlerPublicAPI;
  loadSSR: boolean;
}

export default async function init({ controllerConfig, httpClient, loadSSR, errorHandler }: Params) {
  const platformApi = await getPlatformApi(controllerConfig.platformApiProvider, true);
  const isSSR = platformApi.window.rendering.env === 'backend';
  const liveUpdates: LiveUpdatesConfig | undefined = !isSSR
    ? {
        duplexerClient: await createDuplexerClient({
          getInstance: getInstance(platformApi),
        }),
      }
    : undefined;

  const wixCommentsApi = await initializeCommentsController(
    {
      ...controllerConfig,
      wixCodeApi: { ...controllerConfig.wixCodeApi, ...platformApi },
    },
    {
      appDefinitionId: BLOG_APP_ID,
      liveUpdates,
      httpClient,
      errorHandler,
      shouldAutoBindStateToSetProps: loadSSR ? false : undefined,
      enableWarmupDataCache: loadSSR,
    },
  );

  return { wixCommentsApi, platformApi };
}
